import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * RouteTracker
 * Componente que escucha los cambios de ruta en la SPA (Single Page Application)
 * y emite un evento virtual_page_view al dataLayer de Google Tag Manager (GTM).
 *
 * Permite segmentar fácilmente el tráfico entre:
 * - Landing Page ('/')
 * - Consola y Dashboard ('/dashboard', '/remote', '/player')
 * - Flujos de registro / login y pricing ('/pricing', '/login', etc.)
 */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;

    // Clasificación semántica del tipo de página para simplificar activadores en GTM
    let pageType = 'other';
    if (location.pathname === '/') {
      pageType = 'landing';
    } else if (location.pathname.startsWith('/dashboard')) {
      pageType = 'console_dashboard';
    } else if (location.pathname.startsWith('/remote')) {
      pageType = 'console_remote';
    } else if (location.pathname.startsWith('/player')) {
      pageType = 'console_player';
    } else if (location.pathname.startsWith('/pricing')) {
      pageType = 'pricing';
    } else if (location.pathname.startsWith('/login') || location.pathname.startsWith('/register')) {
      pageType = 'auth';
    }

    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'virtual_page_view',
        page_path: pagePath,
        page_location: window.location.href,
        page_title: document.title,
        page_type: pageType,
      });
    }
  }, [location]);

  return null;
}
